/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q21Inputs */

const et_faq_q21 = /** @type {(inputs: Faq_Q21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kui palju maksab SEO ja digiturundus Eestis?`)
};

const en_faq_q21 = /** @type {(inputs: Faq_Q21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does SEO and digital marketing cost in Estonia?`)
};

/**
* | output |
* | --- |
* | "How much does SEO and digital marketing cost in Estonia?" |
*
* @param {Faq_Q21Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q21 = /** @type {((inputs?: Faq_Q21Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q21Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q21(inputs)
	return en_faq_q21(inputs)
});